import { render, staticRenderFns } from "./VueTour.vue?vue&type=template&id=9b694d8e&"
import script from "./VueTour.vue?vue&type=script&lang=js&"
export * from "./VueTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports